import * as modalTypes from "../../../../constants/modalTypes";
import * as objectTypes from "../../../../constants/objectTypes";
import * as optionHelper from "../../../../helpers/optionHelper";
import * as propertyConstants from "../../../../constants/propertyConstants";
import * as translationHelper from "../../../../helpers/translationHelper";

import { Fandeck, generateFandeckData, generateFandeckHeadings } from "../../../../types/fandeck";
import React, { Component } from "react";

import { ModalParams } from "../../../../types/modalParams";
import { ModalProperties } from "../../../../types/modalProperties";
import { TableContainer } from "../../../Table";
import { TableHeading } from "../../../../types/tableHeading";

import { t as translate } from "react-i18nify";

type Props = {
    tableConstant: string;
    objectType: objectTypes.ObjectType;
    dataPrivileges: any;
    loading: boolean;
    buttonLoading: boolean;
    allList: Array<Fandeck>;
    activeList: Array<Fandeck>;
    availableCount: number | null;
    columnOrder: Array<propertyConstants.Property>;
    columnVisibility: Record<propertyConstants.Property, boolean>;
    columnWidth: Record<propertyConstants.Property, number>;
    offset: number;
    page: number;
    rowCount: number;
    rowCountCustom: boolean;
    search: string | null;
    searchParams: Record<propertyConstants.Property, string>;
    showFilterRow: boolean;
    showGlobalSearch: boolean;
    sortingAsc: boolean;
    sortingCriterion: propertyConstants.Property | null;
    totalCount: number | null;
    useTmcNames: boolean;
};

export class SystemFandeckTable extends Component<Props> {
    generateTableHeadings = (
        modalType: modalTypes.ModalType | null = null,
        objectType: objectTypes.ObjectType = this.props.objectType,
        isPropagating: boolean = false
    ): Array<TableHeading> => {
        const propertyList: Array<propertyConstants.Property> = [
            propertyConstants.PROPERTY_NAME,
            propertyConstants.PROPERTY_SEARCH_NAME,
            propertyConstants.PROPERTY_PRINT_NAME,
            propertyConstants.PROPERTY_CODE,
            propertyConstants.PROPERTY_SEARCH_CODE,
            propertyConstants.PROPERTY_MORE_INFO,
            propertyConstants.PROPERTY_UUID,
            propertyConstants.PROPERTY_PRIORITY,
            propertyConstants.PROPERTY_BARCODES
        ];
        const requiredList: Array<propertyConstants.Property> = [propertyConstants.PROPERTY_NAME];
        const alwaysVisibleList: Array<propertyConstants.Property> = [propertyConstants.PROPERTY_NAME];
        let editableList: Array<propertyConstants.Property> = [...propertyList];
        let visibleList: Array<propertyConstants.Property> = [...propertyList];

        if (this.props.useTmcNames) {
            visibleList.splice(1, 0, propertyConstants.PROPERTY_TMC_NAME);
            editableList.push(propertyConstants.PROPERTY_TMC_NAME);
        }

        if (modalType === null) {
            visibleList.splice(0, 0, propertyConstants.PROPERTY_NAME_MASTER);
        }

        if (modalType === modalTypes.MODAL_SYSTEM_FANDECKS_PROPAGATE) {
            visibleList = [propertyConstants.PROPERTY_NAME_MASTER, propertyConstants.PROPERTY_NAME];
            editableList = [propertyConstants.PROPERTY_NAME];
        }

        if (isPropagating) {
            visibleList = [propertyConstants.PROPERTY_NAME_MASTER];
            editableList = [];
        }

        let orderList = [...visibleList];

        if (modalType === null) {
            orderList = optionHelper.handleTableHeadingOrder(visibleList, this.props.columnOrder);
            visibleList = optionHelper.handleTableHeadingVisibility(visibleList, this.props.columnVisibility);
        }

        return generateFandeckHeadings(
            this.props.objectType,
            orderList,
            visibleList,
            editableList,
            requiredList,
            alwaysVisibleList,
            this.props.columnWidth
        );
    };

    generateAddModalParams = (): ModalParams => {
        return new ModalParams(
            modalTypes.PROPAGATE_MODAL,
            objectTypes.MASTER_SYSTEM_FANDECK,
            "",
            [],
            this.generateTableHeadings(modalTypes.MODAL_SYSTEM_FANDECKS_PROPAGATE, objectTypes.MASTER_SYSTEM_FANDECK),
            undefined,
            this.generateTableHeadings(modalTypes.MODAL_SYSTEM_FANDECKS_PROPAGATE, objectTypes.MASTER_FANDECK, true),
            undefined,
            undefined,
            this.props.dataPrivileges,
            undefined,
            "simple-table"
        );
    };

    generateEditModalParams = (): any => {
        const activeData = generateFandeckData(this.props.activeList);

        if (activeData.length) {
            return new ModalParams(
                modalTypes.EDIT_MODAL,
                this.props.objectType,
                translate("fandeck.editFandeck"),
                activeData[0],
                this.generateTableHeadings(modalTypes.MODAL_FANDECKS_EDIT)
            );
        }

        return null;
    };

    render(): JSX.Element {
        const modalProperties: ModalProperties = {
            addModalType: modalTypes.MODAL_SYSTEM_FANDECKS_PROPAGATE,
            addModalParams: this.generateAddModalParams(),
            editModalType: modalTypes.MODAL_FANDECKS_EDIT,
            editModalParams: this.generateEditModalParams()
        };

        return (
            <div className="height-100">
                <TableContainer
                    className={"table-with-filter"}
                    tableConstant={this.props.tableConstant}
                    objectType={this.props.objectType}
                    dataPrivileges={this.props.dataPrivileges}
                    loading={this.props.loading}
                    buttonLoading={this.props.buttonLoading}
                    title={translationHelper.getTitleSectionTranslation(this.props.objectType)}
                    titleClassName={"main-title"}
                    headings={this.generateTableHeadings()}
                    data={generateFandeckData(this.props.allList)}
                    activeData={this.props.activeList}
                    availableCount={this.props.availableCount}
                    modalProperties={modalProperties}
                    offset={this.props.offset}
                    page={this.props.page}
                    rowCount={this.props.rowCount}
                    rowCountCustom={this.props.rowCountCustom}
                    search={this.props.search}
                    searchParams={this.props.searchParams}
                    showFilterRow={this.props.showFilterRow}
                    showGlobalSearch={this.props.showGlobalSearch}
                    sortingAsc={this.props.sortingAsc}
                    sortingCriterion={this.props.sortingCriterion}
                    totalCount={this.props.totalCount}
                />
            </div>
        );
    }
}
